import React from "react";

const Exit = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 4.55556L12.231 5.80889L14.553 8.11111H5.4V9.88889H14.553L12.231 12.1822L13.5 13.4444L18 9L13.5 4.55556ZM1.8 2.77778H9V1H1.8C0.81 1 0 1.8 0 2.77778V15.2222C0 16.2 0.81 17 1.8 17H9V15.2222H1.8V2.77778Z"
        fill="#C6554F"
      />
    </svg>
  );
};

export default Exit;
